module.exports = __webpack_public_path__ + "static/media/05.790dfd9f.jpg";